<template>
    <div class="size-full rounded-lg border flex flex-col items-center p-[12px]">
        <div class="w-full"><h2 class="flex items-center gap-x-2">Repartition par tranche d'âge <Info :size="15" strokeWidth="1.3"/></h2></div>
        <div class="grow flex gap-x-[16px] justify-between items-center">
            <div class="size-[300px]">
                <apexchart type="donut" :options="options" :series="series" width="100%" height="100%"></apexchart>
            </div>
            <div class="grow w-full justify-end flex flex-col gap-y-[6px] text-[14px]">
                <div class="flex items-center gap-x-6">
                    <div class="flex items-center gap-x-2">
                        <div  class="size-4 rounded-md bg-[#fe713c]"/>
                        <span class="font-extralight">18-25 ans</span>
                    </div>
                    <div class="grow h-1/2 self-end border-t border-dashed"/>
                    <span class="font-extralight">{{ a }}%</span>
                </div>

                <div class="flex items-center gap-x-6">
                    <div class="flex items-center gap-x-2">
                        <div  class="size-4 rounded-md bg-[#ee4636]"/>
                        <span class="font-extralight">26-35 ans</span>
                    </div>
                    <div class="grow h-1/2 self-end border-t border-dashed"/>
                    <span class="font-extralight">{{ b }}%</span>
                </div>

                <div class="flex items-center gap-x-6">
                    <div class="flex items-center gap-x-2">
                        <div  class="size-4 rounded-md bg-[#099556]"/>
                        <span class="font-extralight">36-45 ans</span>
                    </div>
                    <div class="grow h-1/2 self-end border-t border-dashed"/>
                    <span class="font-extralight">{{ c }}%</span>
                </div>

                <div class="flex items-center gap-x-6">
                    <div class="flex items-center gap-x-2">
                        <div  class="size-4 rounded-md bg-[#5589f6]"/>
                        <span class="font-extralight">46-55 ans</span>
                    </div>
                    <div class="grow h-1/2 self-end border-t border-dashed"/>
                    <span class="font-extralight">{{ d }}%</span>
                </div>

                <div class="flex items-center gap-x-6">
                    <div class="flex items-center gap-x-2">
                        <div  class="size-4 rounded-md bg-[#55f6c6]"/>
                        <span class="font-extralight">56-65 ans</span>
                    </div>
                    <div class="grow h-1/2 self-end border-t border-dashed"/>
                    <span class="font-extralight">{{ e }}%</span>
                </div>

                <div class="flex items-center gap-x-6">
                    <div class="flex items-center gap-x-2">
                        <div  class="size-4 rounded-md bg-[#f6ab55]"/>
                        <span class="font-extralight">66-75 ans</span>
                    </div>
                    <div class="grow h-1/2 self-end border-t border-dashed"/>
                    <span class="font-extralight">{{ f }}%</span>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import {Info} from "lucide-vue-next"
export default {
    name: "RangeAgeDonut",
    components:{
        Info
    },
    props:["datas"],
    data(){
        return {
            series: [],
            a:0,
            b:0,
            c:0,
            d:0,
            e:0,
            f:0,
            options:{
                chart: {
                    width: "auto",
                    type: 'donut',
                    toolbar: {  
                        show: false
                    },
                },
                stroke: {
                    width: 2,
                },
                labels: ['18-25 ans', '26-35 ans', '36-45 ans', '46-55 ans','56-65 ans','66-75 ans'],
                colors: ['#fe713c', '#ee4636','#099556','#5589f6','#55f6c6','#f6ab55'],
                plotOptions:{
                    pie:{
                        expandOnClick: false,
                        donut:{
                            size: '85%',
                            labels:{
                                show: true,
                                total: {
                                    show: true,
                                    label: 'Total',
                                    fontWeight: 100,
                                    fontSize: '14px',
                                    formatter: function(w) {
                                        let total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                                        return total.toFixed(0);
                                    }
                                }
                            }
                        },
                    }
                },
                dataLabels: {
                    enabled: false
                    },
                    legend:{
                        show:false
                },
            }
        }
    },
    mounted(){
        this.series = [
            this.datas["18-25"] || 0,
            this.datas["26-35"] || 0,
            this.datas["36-45"] || 0,
            this.datas["46-55"] || 0,
            this.datas["56-65"] || 0,
            this.datas["66-75"] || 0
        ]
        this.a = this.calculPercent(this.series[0],this.series.reduce((acc,item)=> acc+item,0));
        this.b = this.calculPercent(this.series[1],this.series.reduce((acc,item)=> acc+item,0));
        this.c = this.calculPercent(this.series[2],this.series.reduce((acc,item)=> acc+item,0));
        this.d = this.calculPercent(this.series[3],this.series.reduce((acc,item)=> acc+item,0));
        this.e = this.calculPercent(this.series[4],this.series.reduce((acc,item)=> acc+item,0));
        this.f = this.calculPercent(this.series[5],this.series.reduce((acc,item)=> acc+item,0));
    },
    methods:{
        calculPercent(range_value,sum){
            return Math.ceil((range_value/ sum)*100)
        }
    },
}
</script>